import React from "react";
import Lottie from "lottie-react";

import shopping from "../assets/Green loading bar.json"; 

const EndAnimation = ({ animationData = shopping }) => {
  return (
    <div className="end-animation my-4 d-flex justify-content-center">
      <div className="animation-wrapper w-100" style={{ maxWidth: "400px" }}>
        <Lottie
          animationData={animationData}
          loop={true}
          style={{ width: "100%", height: "auto" }}
        />
      </div>
    </div>
  );
};

export default EndAnimation;
